var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClients = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.22266 9.88886C7.22266 10.3604 7.40996 10.8125 7.74336 11.1459C8.07675 11.4793 8.52894 11.6666 9.00043 11.6666C9.47193 11.6666 9.92411 11.4793 10.2575 11.1459C10.5909 10.8125 10.7782 10.3604 10.7782 9.88886C10.7782 9.41737 10.5909 8.96518 10.2575 8.63178C9.92411 8.29839 9.47193 8.11108 9.00043 8.11108C8.52894 8.11108 8.07675 8.29839 7.74336 8.63178C7.40996 8.96518 7.22266 9.41737 7.22266 9.88886Z",
  stroke: "#C9C9C9",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.44531 17V16.1112C5.44531 15.6397 5.63261 15.1875 5.96601 14.8541C6.29941 14.5207 6.75159 14.3334 7.22309 14.3334H10.7786C11.2501 14.3334 11.7023 14.5207 12.0357 14.8541C12.3691 15.1875 12.5564 15.6397 12.5564 16.1112V17",
  stroke: "#C9C9C9",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.668 2.77778C11.668 3.24927 11.8553 3.70146 12.1887 4.03486C12.5221 4.36825 12.9743 4.55556 13.4457 4.55556C13.9172 4.55556 14.3694 4.36825 14.7028 4.03486C15.0362 3.70146 15.2235 3.24927 15.2235 2.77778C15.2235 2.30628 15.0362 1.8541 14.7028 1.5207C14.3694 1.1873 13.9172 1 13.4457 1C12.9743 1 12.5221 1.1873 12.1887 1.5207C11.8553 1.8541 11.668 2.30628 11.668 2.77778Z",
  stroke: "#C9C9C9",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4453 7.22217H15.2231C15.6946 7.22217 16.1468 7.40947 16.4802 7.74287C16.8136 8.07627 17.0009 8.52845 17.0009 8.99995V9.88883",
  stroke: "#C9C9C9",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.77734 2.77778C2.77734 3.24927 2.96464 3.70146 3.29804 4.03486C3.63144 4.36825 4.08363 4.55556 4.55512 4.55556C5.02662 4.55556 5.4788 4.36825 5.8122 4.03486C6.1456 3.70146 6.3329 3.24927 6.3329 2.77778C6.3329 2.30628 6.1456 1.8541 5.8122 1.5207C5.4788 1.1873 5.02662 1 4.55512 1C4.08363 1 3.63144 1.1873 3.29804 1.5207C2.96464 1.8541 2.77734 2.30628 2.77734 2.77778Z",
  stroke: "#C9C9C9",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M1 9.88883V8.99995C1 8.52845 1.1873 8.07627 1.5207 7.74287C1.8541 7.40947 2.30628 7.22217 2.77778 7.22217H4.55556",
  stroke: "#C9C9C9",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgClients;